import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useArticleCreate } from '@/module/Author/Article/model/ArticleQuery';
import { ArticleSchema, articleSchema, defaultArticleValues } from '@/module/Author/Article/model/ArticleSchema';

import { useAppNotification } from '@feature/utils';

import { ArticleForm } from './ArticleForm';

export function ArticleCreate() {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useArticleCreate();
  const navigate = useNavigate();
  const notification = useAppNotification();

  const onSubmit = (values: ArticleSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newArticle => {
        notification.success();
        navigate({ to: '/author/article/$articleId', params: { articleId: String(newArticle.id) } });
      },
    });
  };

  return (
    <ArticleForm
      title={t('articles.form.title.create')}
      schema={articleSchema}
      defaultValues={defaultArticleValues}
      values={undefined}
      isSubmitting={isPending}
      isError={isError}
      isSuccess={isSuccess}
      onSubmit={onSubmit}
      onCancel={() => navigate({ to: '..' })}
      showWosFields={false}
      showScopusFields={false}
    />
  );
}
